import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'https://sohaibenterprises.cloud/api';

const StatCard = ({ icon, label, value, sub, color }) => (
  <div style={{
    background: 'white', borderRadius: '16px', padding: '24px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.08)', borderLeft: `4px solid ${color}`,
    display: 'flex', flexDirection: 'column', gap: '8px'
  }}>
    <div style={{ fontSize: '32px' }}>{icon}</div>
    <div style={{ fontSize: '14px', color: '#7f8c8d', fontWeight: '500' }}>{label}</div>
    <div style={{ fontSize: '28px', fontWeight: '700', color: '#2c3e50' }}>{value}</div>
    {sub && <div style={{ fontSize: '13px', color: '#95a5a6' }}>{sub}</div>}
  </div>
);

const DashboardTab = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/agriculture/dashboard`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => { setData(res.data.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: '60px', fontSize: '18px', color: '#7f8c8d' }}>Loading dashboard...</div>;
  if (!data) return <div style={{ textAlign: 'center', padding: '60px', fontSize: '18px', color: '#e74c3c' }}>Failed to load dashboard.</div>;

  const fmt = (n) => `Rs ${Number(n || 0).toLocaleString()}`;
  const totalAcres = parseFloat(data.lands?.total_acres || 0).toFixed(2);
  const totalKanals = parseInt(data.lands?.total_kanals || 0);

  return (
    <div>
      <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#2c3e50', marginBottom: '24px' }}>Agriculture Overview</h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '32px' }}>
        <StatCard icon="🌍" label="Active Lands" value={data.lands?.total || 0} sub={`${totalKanals} kanals (${totalAcres} acres)`} color="#27ae60" />
        <StatCard icon="📐" label="Total Kanals" value={totalKanals} sub={`${totalAcres} acres total`} color="#16a085" />
        <StatCard icon="🌱" label="Growing Crops" value={data.crops?.growing || 0} sub={`${data.crops?.harvested || 0} harvested`} color="#2ecc71" />
        <StatCard icon="💰" label="Monthly Income" value={fmt(data.finance?.monthly_income)} sub="This month" color="#3498db" />
        <StatCard icon="📉" label="Monthly Expenses" value={fmt(data.finance?.monthly_expense)} sub="This month" color="#e74c3c" />
        <StatCard icon="📈" label="Monthly Profit" value={fmt(data.finance?.monthly_profit)} sub="This month" color="#9b59b6" />
        <StatCard icon="👷" label="Labor Cost" value={fmt(data.labor?.monthly_cost)} sub="This month" color="#f39c12" />
        <StatCard icon="🏪" label="Yearly Sales" value={fmt(data.sales?.yearly_total)} sub="Harvest sales" color="#1abc9c" />
      </div>

      {/* Crop Status Summary */}
      <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)' }}>
        <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#2c3e50', marginBottom: '20px' }}>Crop Status Summary</h3>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {[
            { status: 'growing',   color: '#27ae60', icon: '🌱' },
            { status: 'harvested', color: '#3498db', icon: '🌾' },
            { status: 'sold',      color: '#9b59b6', icon: '💰' },
            { status: 'failed',    color: '#e74c3c', icon: '❌' },
          ].map(({ status, color, icon }) => (
            <div key={status} style={{
              flex: '1', minWidth: '120px', background: `${color}15`,
              border: `2px solid ${color}30`, borderRadius: '12px',
              padding: '16px', textAlign: 'center'
            }}>
              <div style={{ fontSize: '28px' }}>{icon}</div>
              <div style={{ fontSize: '24px', fontWeight: '700', color }}>{data.crops?.[status] || 0}</div>
              <div style={{ fontSize: '13px', color: '#7f8c8d', textTransform: 'capitalize' }}>{status}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardTab;